import { useEffect, useRef, useState } from 'react';
import ReactModal from 'react-modal';

import { useAuth } from 'context/AuthContext';
import { actionLog } from 'services/actionlog.service';
import { RegulamentoContent } from 'components/regulamento-content';
import { getStorageItem, removeStorageItem, setStorageItem } from 'utils/storage';
import { checkInvite } from 'services/dashboard.service';

// interface RegulamentoModalProps {
//   on
// }

export function RegulamentoModal(props: any) {
  // const modalID = "achievement";

  // const modalID = 'help-pontos';

  const [modalIsOpen, setIsOpen] = useState(false);

  const { signOut, refreshUser, user } = useAuth();

  // const { openModal, closeModal } = useContext(ModalContext);

  const acceptRef = useRef<any>();

  const [accept, setAccept] = useState(false);
  const [willOpen, setWillOpen] = useState(true);

  ReactModal.setAppElement('#modal');

  function handleCloseModal() {
    //
  }

  function afterOpenModal() {
    //
  }

  function handleAccept(e: any) {
    setAccept(e.target.checked);
  }

  async function handleSubmit() {
    if (!user) return;

    setIsOpen(false);
    setStorageItem('accept', 'true');

    await actionLog('me', 'accept_rules');

    const sender = getStorageItem('dti360_invite_code');

    if (typeof sender === 'string') {
      const hasInvite = await checkInvite(user._id, sender);

      if (hasInvite) {
        await actionLog('me', 'accept_invite', { sender });
      }

      removeStorageItem('dti360_invite_code');
    }

    refreshUser();
  }

  useEffect(() => {
    if (user) {
      const readOnly = localStorage.getItem('readOnly');
      const _accept = localStorage.getItem('accept');

      if (readOnly && _accept) {
        setIsOpen(false);
        return;
      }

      /* Quem pediu para sair não deve ser cobrado a aceitar o regulamento. A
         modal é irmã de {children} dentro do PrivateRoute, então ela abriria
         por cima da tela de saída mesmo com o Dashboard devolvendo outra coisa. */
      if (user.extra.active === false) {
        setIsOpen(false);
        return;
      }

      try {
        setIsOpen(!user.extra.accept);
      } catch (e) {
        setIsOpen(false);
      }
    }
  }, [user]);

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel="Example Modal"
        portalClassName="relative z-50"
        overlayClassName="rb-modal-overlay rb-modal-overlay--top"
        contentElement={() => (
          <div className="rb-modal rb-modal--lg">
            <div className="rb-modal__header">
              <h1 className="rb-modal__title">Regulamento</h1>
            </div>

            <div className="space-y-5 h-[35vh] overflow-y-auto mb-4">
              <RegulamentoContent modal rede={user?.extra.rede} />
            </div>

            <div className="rb-modal__field" style={{ border: '1px solid var(--color-border-light)', borderRadius: 'var(--radius-md)', padding: 14, marginBottom: 0 }}>
              <label className="rb-modal__text" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, margin: 0 }}>
                <input
                  id="accept"
                  type="checkbox"
                  name="accept"
                  onChange={e => handleAccept(e)}
                  ref={ref => {
                    acceptRef.current = ref;
                  }}
                />
                Concordo com os termos e condições do regulamento do Reconheça BRB
              </label>
            </div>

            <div className="rb-modal__actions">
              <button className="rb-btn-ghost" onClick={() => signOut()}>
                Sair do Reconheça BRB
              </button>
              <button className="rb-btn-primary" disabled={!accept} onClick={() => handleSubmit()}>
                Confirmar participação
              </button>
            </div>
          </div>
        )}
      />
    </>
  );
}
